// import { useNProgress } from '@vueuse/integrations/useNProgress'
// import { ref, watch } from 'vue'

export const useProgress = () => {
  const { isLoading, progress, start, done } = {
    isLoading: { value: false },
    progress: { value: 0 },
    start: () => {
      isLoading.value = true
      progress.value = 0.1
    },
    done: () => {
      progress.value = 1
      isLoading.value = false
    }
  }
  // const queueProgress = ref([])

  // watch(
  //   () => queueProgress.value,
  //   (value) => {
  //     if (value.length > 0) {
  //       progress.value = 
  //       start()
  //     } else {
  //       done()
  //     }
  //   }
  // )

  return {
    isLoading,
    progress,
    start,
    done
  }
}